import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import EsqueletoCargando from "componentes/EsqueletoCargando";
import axios from "helpers/API";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Box, TextField } from "@material-ui/core";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import CircularProgress from "@material-ui/core/CircularProgress";
import Permission from "helpers/Permission";
import { getPermisoDefinicion } from "helpers/helpers";
import { PERMISOS } from "helpers/PermisosConfig";
import { useHistory } from "react-router-dom";
import { errorBackendMsg, getValorEditarODefault } from "helpers/helpers";
import usePermisos from "helpers/usePermisos";

const useStyles = makeStyles((theme) => ({
    cardCrear: {
        height: 120,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            cursor: "pointer",
        },
    },
    inputNuevaBanda: {
        width: "100%",
    },
}));

function UsuariosLista({ keyLista, setKeyLista }) {
    const classes = useStyles();
    const history = useHistory();
    const [drawer, setDrawer] = React.useState(false);
    const [cargando, setCargando] = React.useState(false);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);
    const [mensajeInfo, setMensajeInfo] = useState("");
    const [showInfo, setShowInfo] = useState(false);

    const [userData, setUserData] = useState(null);
    //PERMISOS
    const {
        permisosCargados,
        accesoDenegado,
    } = usePermisos({ 
            redireccionar: false,
            modulo: getPermisoDefinicion(
                PERMISOS.P_MODIFICAR_DATOS_CUENTA
            )["modulo"],
            pantalla: getPermisoDefinicion(
                PERMISOS.P_MODIFICAR_DATOS_CUENTA
            )["pantalla"]
    })



    useEffect(() => {
        // consultarPermisos();
        getUserData();
    }, []);

    // const consultarPermisos = () => {
    //     const permissionConfig = {
    //         modulo: getPermisoDefinicion(PERMISOS.P_MODIFICAR_DATOS_CUENTA)[
    //             "modulo"
    //         ],
    //         pantalla: getPermisoDefinicion(PERMISOS.P_MODIFICAR_DATOS_CUENTA)[
    //             "pantalla"
    //         ],
    //         history: history,
    //         setLoadingPermisos: setEstaCargandoPermisos,
    //         setAccesoDenegado: setAccesoDenegado,
    //     };

    //     new Permission(permissionConfig).applyPermission();
    // };

    const peticionBase = ({
        url,
        dataRequest = {},
        hook = false,
        errorHook = false,
    }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    if (Boolean(errorHook)) {
                        errorHook(response.data);
                    } else {
                        setShowError(true);
                        setMensajeError(response.data.msg);
                    }
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setMensajeError(errorBackendMsg(error));
            });
    };

    const getUserData = () => {
        let peticion = {
            url: "/seguridad/usuarios/obtenerme",
            hook: setUserData,
        };
        peticionBase(peticion);
    };

    const handleSubmit = (values) => {
        const hook = (data) => {
            setShowInfo(true);
            setMensajeInfo(data.msg);
            getUserData();
        };
        let peticion = {
            url: "/seguridad/usuarios/editarme",
            hook: hook,
            dataRequest: { ...values },
        };
        peticionBase(peticion);
    };

    const WrapperStyles = ({ children }) => {
        return (
            <div
                style={{
                    backgroundColor: "#fafafa",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                    marginBottom: 0,
                    marginTop: 0,
                }}
            >
                {children}
            </div>
        );
    };

    const Render = () => {
        if (!permisosCargados) {
            return (
                <WrapperStyles>
                    <CircularProgress />
                </WrapperStyles>
            );
        } else {
            if (accesoDenegado) {
                return (
                    <WrapperStyles>
                        <Typography variant="h2">Acceso Denegado</Typography>
                    </WrapperStyles>
                );
            } else {
                return <Main />;
            }
        }
    };

    const Main = () => {
        const validationSchema = Yup.object({
            nombre: Yup.string().trim().required("Campo requerido"),
            apellido: Yup.string().trim().required("Campo requerido"),
            email: Yup.string()
                .email("Email no válido")
                .required("Campo requerido"),
        });

        const formik = useFormik({
            initialValues: {
                nombre: getValorEditarODefault(userData, "nombre", ""),
                apellido: getValorEditarODefault(userData, "apellido", ""),
                email: getValorEditarODefault(userData, "email", ""),
            },
            enableReinitialize: true,
            validationSchema: validationSchema,
            onSubmit: (values, { setSubmitting }) => {
                handleSubmit(values);
                setSubmitting(false);
            },
        });

        return (
            <>
                <Box>
                    <APIMensajeMUI
                        mb={30}
                        tipo="info"
                        showMensaje={showInfo}
                        msg={mensajeInfo}
                    />
                    <APIMensajeMUI
                        mb={30}
                        tipo="error"
                        showMensaje={showError}
                        msg={mensajeError}
                    />
                </Box>
                <Grid container spacing={2}>
                    <Drawer
                        className={classes.drawerBanda}
                        anchor="right"
                        open={drawer}
                        onClose={() => setDrawer(false)}
                    ></Drawer>
                    <Grid
                        item
                        md={12}
                        style={{ display: "flex", justifyContent: "center" }}
                    >
                        {cargando ? (
                            <EsqueletoCargando />
                        ) : (
                            <Card style={{ width: "50%", padding: "2em" }}>
                                <form onSubmit={formik.handleSubmit}>
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            marginBottom: "1em",
                                        }}
                                        variant="h5"
                                    >
                                        Formulario
                                    </Typography>
                                    <Box mt={1}>
                                        <TextField
                                            variant="outlined"
                                            className={classes.inputNuevaBanda}
                                            label="Nombres"
                                            type="text"
                                            id="nombre"
                                            name="nombre"
                                            value={formik.values.nombre}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.nombre &&
                                                Boolean(formik.errors.nombre)
                                            }
                                            helperText={
                                                formik.touched.nombre &&
                                                formik.errors.nombre
                                            }
                                        />
                                    </Box>
                                    <Box mt={1}>
                                        <TextField
                                            variant="outlined"
                                            className={classes.inputNuevaBanda}
                                            label="Apellido"
                                            type="text"
                                            id="apellido"
                                            name="apellido"
                                            value={formik.values.apellido}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.apellido &&
                                                Boolean(formik.errors.apellido)
                                            }
                                            helperText={
                                                formik.touched.apellido &&
                                                formik.errors.apellido
                                            }
                                        />
                                    </Box>
                                    <Box mt={1}>
                                        <TextField
                                            variant="outlined"
                                            className={classes.inputNuevaBanda}
                                            label="Email"
                                            type="text"
                                            id="email"
                                            name="email"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.email &&
                                                Boolean(formik.errors.email)
                                            }
                                            helperText={
                                                formik.touched.email &&
                                                formik.errors.email
                                            }
                                        />
                                    </Box>

                                    <Box mt={3} style={{ float: "right" }}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                        >
                                            Guardar
                                        </Button>
                                    </Box>
                                </form>
                            </Card>
                        )}
                    </Grid>
                </Grid>
            </>
        );
    };

    return <Render />;
}
export default UsuariosLista;
